import React from "react";

export default function({style, ...props}){
    return <svg viewBox="0 0 100 100" style={{
        fill: "none",
        stroke: "#fc0",
        ...style
    }} {...props}>
        <g transform="matrix(1.38861,0,0,1.6008,-16.5866,-20.4583)">
            <path
                d="M83.239,19.572C83.239,16.168 80.053,13.405 76.13,13.405L19.774,13.405C15.851,13.405 12.665,16.168 12.665,19.572L12.665,68.457C12.665,71.861 15.851,74.624 19.774,74.624L76.13,74.624C80.053,74.624 83.239,71.861 83.239,68.457L83.239,19.572Z"
                style={{strokeWidth: 1.33}}
            />
        </g>
        <path d="M1,50L99,50" style={{strokeWidth:2}} />
    </svg>
}
